import { AvatarType } from "./avatar_types"

export enum ProfileRoles {
  SUPER = 'super',
  COMMONER = 'commoner'
}

export type ProfileRolesType = 'super' | 'commoner'

export interface ProfileType {
  id: string
  creation_time: string
  modification_time: string
  name: string
  has_seen_byol_tutorial: boolean
  has_seen_purchase_link_tutorial: boolean
  role: ProfileRolesType
  birthday: string
  avatar: AvatarType
}